import * as types from '@store/types'
import graphQL from '@queries'
import axios from 'axios'
import NegativeExperienceQuery from '@queries/NegativeExperience'

const state = {
  types: []
}

const getters = {
  [types.NEGATIVE_EXPERIENCE_TYPES]: ({ types }) => types
}

const mutations = {
  [types.NEGATIVE_EXPERIENCE_TYPES]: (state, payload) => {
    state.types = payload
  }
}

const actions = {
  [types.NEGATIVE_EXPERIENCE]: async ({ getters }, payload) => {
    const { id: campaign } = getters[types.CAMPAIGN]
    const path = `campaign/${campaign}/negative-experience`
    const response = await axios.post(path, payload)
    return response.data.success
  },
  [types.NEGATIVE_EXPERIENCE_TYPES]: async ({ commit }) => {
    const response = await graphQL(NegativeExperienceQuery, {})
    const { negativeExperience } = response.data.data
    commit(types.NEGATIVE_EXPERIENCE_TYPES, negativeExperience)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/negativeExperience.js